import { useContext } from 'react';

import PageContext from '@rover/react-lib/src/context/PageContext';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

import useDucks from './useDucks';

type SelectorProps = {
  isBrightHorizonsUser: boolean;
};

const selector = (state): SelectorProps => ({
  isBrightHorizonsUser: currentUserSelectors.getIsBrightHorizonsUser(state),
});

const useIsBHUserShim = (): boolean => {
  const { isReactQueryRoute = true } = useContext(PageContext) || {};
  const { user } = useCurrentUser({ enabled: isReactQueryRoute });
  const { data: selectedData } = useDucks({ selector });
  const isBHUser = isReactQueryRoute
    ? user?.isBrightHorizonsUser
    : selectedData?.isBrightHorizonsUser;

  return !!isBHUser;
};

export default useIsBHUserShim;
